import { render, staticRenderFns } from "./MarketplaceScreen.vue?vue&type=template&id=501a6a37&scoped=true"
import script from "./MarketplaceScreen.vue?vue&type=script&lang=js"
export * from "./MarketplaceScreen.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceScreen.vue?vue&type=style&index=0&id=501a6a37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501a6a37",
  null
  
)

export default component.exports